module.exports = __webpack_public_path__ + "img/venta-directa.8b83864e.jpeg";